// Login Api
export const LOGIN_URL = "/login";
export const LOGOUT_URL = "/logout";
export const SEND_EMAIL_URL = "/forgot-password";
export const RESET_PASSWORD_URL = "/reset-password";

// Dashboard Api
export const DASHBOARD_DATA_API_URL = "/dashboard";

// Accounts Api
export const ACCOUNTS_API_URL = "/account";

// Menu Api
export const MENU_API_URL = "/menu";


// Super Admin APIs
export const SUPER_ADMIN_API_URL = "/super-admin";

// Admin Manager APIs
export const RESTAURANT_ADMIN_API_URL = "/admin";

// Admin User APIs
export const ADMIN_API_URL = "/admin";

export const USER_API_URL = "/res-user";

export const COMMON_DATA_API_URL = "/common-data";

export const ACCOUNT_SUMMARY_API_URL = "/account-summary";

// Order APIs
export const ORDER_API_URL = "/order";

// Table APIs
export const TABLES_API_URL = "/table";

// Inventory APIs
export const INVENTORY_API_URL = "/inventory";

export const FILE_UPLOAD_URL = "/upload";